export function openUrl(url: string) {
  window.open(url, '_blank')?.focus()
}
